import * as actionTypes from 'modules/serviceHeaders/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Array<import('modules/serviceHeaders/types/wrappedServiceHeader').WrappedServiceHeader>} ServiceHeaderEntriesReducer */
const initialState = [];

const reset = () => initialState;

/**
 * @param {ServiceHeaderEntriesReducer} _
 * @param {import('modules/serviceHeaders/types/actions').FetchServiceHeaderSuccessAction} action
 * @returns {ServiceHeaderEntriesReducer}
 */
const afterFetchEntries = (_, { payload }) => payload;

export default createReducer(initialState, {
  [actionTypes.FETCH_SERVICE_HEADER]: reset,
  [actionTypes.FETCH_SERVICE_HEADER_SUCCESS]: afterFetchEntries,
});
